import {Observable} from 'rxjs/Observable';
import FileStackClient from 'utils/filestack';
import {isNoU, makeDBOriginalImageUrl} from "utils/DBUtils";
import {makePickOptions, multiFilePromiseHandler} from "./utils";
import ImageDimensions from 'utils/ImageDimensions';
import {GIFType} from "../../utils/ImageDimensions";

export function doCropOriginal(observer, {originalImage, imageType}) {
  let url = makeDBOriginalImageUrl(originalImage.id);

  // Just need dimensions for aspect ratio, so either retina or regular would work
  let imageDimensions = ImageDimensions[imageType];
  if (isNoU(imageDimensions)) {
    throw new Error(`Image type ${imageType} is not in image dimensions map.`);
  }

  let retinaDim = imageDimensions.retina;

  let transformationOptions = {
    transformations: {}
  };

  // Aspect Calc
  let aspect = null;
  if (!isNoU(retinaDim.x) && !isNoU(retinaDim.y)) { // Both exist
    aspect = retinaDim.x / retinaDim.y;
  }

  // Attempt at only specifying on dimension
  // think it'll actually require some resize math after a crop
  // else if (isNoU(retinaDim.x) && !isNoU(retinaDim.y)) { // Only y exists
  //   transformationOptions.imageDim = [null, retinaDim.y];
  // } else if (!isNoU(retinaDim.x) && isNoU(retinaDim.y)) { // Only x exists
  //   transformationOptions.imageDim = [retinaDim.x, null];
  // }

  // Only supporting specifying both dimensions or neither (free form crop)
  transformationOptions.transformations.crop = {
    force: true
  };
  if (aspect) {
    transformationOptions.transformations.crop.aspectRatio = aspect;
  }

  if (imageType === GIFType) {
    // Cropping a gif only renders first frame
    transformationOptions.transformations.crop = false;
  }

  let options = makePickOptions(transformationOptions, observer);

  multiFilePromiseHandler(observer, FileStackClient.cropFiles([url], options));
}

export function cropOriginal() {
  return (source) => Observable.create((observer) => {
    source.subscribe(
      (file) => console.log('converting', file),
      (err) => observer.error(err),
      () => observer.complete()
    );
  })
}


// WEBPACK FOOTER //
// ./public/observables/lettables/cropOriginal.js